import React from 'react';
import { Link } from 'react-router-dom';
const CDN_URL = process.env.REACT_APP_CDN_URL;

const blockWhite = `${CDN_URL}common/BLOXModules_Single_Blank_TemporaryLighterVersion.svg`;

const Block = props => {
	const { hasAccess, src, type, url, id, onMouseOver, onMouseOut } = props;

	if (!hasAccess) {
		return (
			<div className='block'>
				<img src={blockWhite} className='blox' alt='blox' />
			</div>
		);
		//eslint-disable-next-line
	} else if (!type == 'clickable' || !type) {
		return (
			<div className='block'>
				<img src={src || blockWhite} className='blox' alt='blox' />
			</div>
		);
	} else {
		return (
			<div className='block blox-clickable' id={`blox-clickable-${id}`}>
				<Link to={url}>
					<div
						className={`blox-clickable-area ${id}`}
						onMouseOver={() => onMouseOver(id)}
						onMouseOut={() => onMouseOut(id)}
					/>
					<img src={src} className='blox' alt='blox' id={id} />
				</Link>
			</div>
		);
	}
};
export default Block;
